import { c as _c } from "react/compiler-runtime";
import { Checkbox } from '@sprd/sprd-component-kit/v2';
import { ReactNode, useCallback } from 'react';
import clsx from 'clsx';
type CheckboxFilterContentProps = {
  className?: string;
  label: string;
  options: {
    label: ReactNode;
    value: string;
  }[];
  selected?: string[];
  onChange: (selected: string[] | undefined) => void;
};
export const CheckboxFilterContent = t0 => {
  const $ = _c(20);
  const {
    className,
    label,
    options,
    selected: t1,
    onChange
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const selected = t2;
  let t3;
  if ($[2] !== onChange || $[3] !== selected) {
    t3 = (value, checked) => {
      const newSelected = checked ? [...selected, value] : selected.filter(v => v !== value);
      onChange(newSelected.length > 0 ? newSelected : undefined);
    };
    $[2] = onChange;
    $[3] = selected;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleToggle = t3;
  let t4;
  if ($[5] !== className) {
    t4 = clsx("flex flex-col gap-4", className);
    $[5] = className;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== label) {
    t5 = <legend className="sr-only">{label}</legend>;
    $[7] = label;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== handleToggle || $[10] !== options || $[11] !== selected) {
    let t7;
    if ($[13] !== handleToggle || $[14] !== selected) {
      t7 = option => {
        const isChecked = selected.includes(option.value);
        return <Checkbox label={option.label as string} key={option.value} checked={isChecked} onChange={() => handleToggle(option.value, !isChecked)} className="relative" />;
      };
      $[13] = handleToggle;
      $[14] = selected;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = options.map(t7);
    $[9] = handleToggle;
    $[10] = options;
    $[11] = selected;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className="w-full"><fieldset className={t4}>{t5}{t6}</fieldset></div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};